import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";
import Country from "@/pcm/store/models/Country";
import ClientPaymentInformation from "@/pcm/store/models/ClientPaymentInformation";
import ClientContract from "@/pcm/store/models/ClientContract";
import Client from "@/pcm/store/models/Client";

export default class NewClient extends Model {
    static entity = 'new_clients';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'name',
    };

    static fields() {
        return {
            id: this.uid(),
            client_id: this.attr(null),
            country_id: this.attr(null),
            sign_type: this.string(''),
            name: this.string(''),
            alias: this.string(''),
            address: this.string(null).nullable(),
            zip: this.string(null).nullable(),
            company: this.string(null).nullable(),
            chamber_of_commerce: this.string(null).nullable(),
            vat_number: this.string(null).nullable(),
            youtube_url: this.string(null).nullable(),
            payment_method: this.string(''),

            created_at: this.string(''),
            updated_at: this.string(''),

            // Relations
            country: this.belongsTo(Country, 'country_id'),
            new_client_payment_information: this.hasOne(ClientPaymentInformation, 'client_id'),
            client: this.belongsTo(Client, 'client_id'),
        }
    }

    declare id: number;
    declare user_id: number;
    declare country_id: number;
    declare sign_type: string;
    declare name: string;
    declare alias: string;
    declare email: string | null;
    declare address: string | null;
    declare zip: string | null;
    declare company: string | null;
    declare chamber_of_commerce: string | null;
    declare vat_number: string | null;
    declare revenue_share: string | null;
    declare youtube_url: string | null;
    declare max_downloads_per_day: number | null;
    declare payment_method: string;
    declare has_media_access: string;
    declare is_invited: string;
    declare has_password: boolean;
    declare country: Country | null;
    declare new_client_payment_information: ClientPaymentInformation | null;
    declare client_contracts: Array<ClientContract> | null;
}
